import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateProjectDetailsRPC } from "./updateProjectDetailsRPC";

export class UpdateProjectDetailsRPCClientImpl extends UpdateProjectDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateProjectDetailsRPC.Request): Promise<LeoRPCResult<UpdateProjectDetailsRPC.Response, UpdateProjectDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/UpdateProjectDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateProjectDetailsRPC.ResponseDTO,
      UpdateProjectDetailsRPC.Errors.ErrorsDTO,
      UpdateProjectDetailsRPC.Response,
      UpdateProjectDetailsRPC.Errors.Errors
    >(
      response,
      "project/UpdateProjectDetails",
      UpdateProjectDetailsRPC.Response.fromDTO,
      UpdateProjectDetailsRPC.Errors.fromDTO
    );
  }
}
